<ng-container *ngIf="authorization; else noAuth">
  <app-toolbar [back]="back" [destination]="destination" [title]="title" [user]="user"></app-toolbar>

  <div class="form" style="padding-bottom: 70px; max-width: 1000px">
    <div style="padding: 20px 30px;">
      <h3 style="text-align: center">MIAH-UC (per Colite ulcerosa)</h3>
    </div>
    <form [formGroup]="qForm" (ngSubmit)="onSubmit()">

      <div class="container mat-elevation-z5">

        <table mat-table [dataSource]="dataSource">

          <ng-container matColumnDef="position">
            <th mat-header-cell *matHeaderCellDef> No. </th>
            <td mat-cell *matCellDef="let questionnaire"> {{questionnaire.position}} </td>
          </ng-container>


          <ng-container matColumnDef="question">
            <th mat-header-cell *matHeaderCellDef> Domanda </th>
            <td mat-cell *matCellDef="let questionnaire"> {{questionnaire.question}}</td>
          </ng-container>

          <ng-container matColumnDef="value">
            <th mat-header-cell *matHeaderCellDef> Valore </th>
            <td mat-cell *matCellDef="let questionnaire">
              <ng-container *ngIf="questionnaire.position === 3">
                <mat-form-field>
                  <mat-label>Inserisci un numero</mat-label>
                  <input matInput type="number" (change)="setResult(questionnaire.position)"
                         formControlName="{{q+questionnaire.position}}" (focusin)="notFocused=false" (focusout)="notFocused=true">
                  <mat-error *ngIf="(qForm.get('question3').hasError('min') && notFocused)">
                    Inserisci un numero
                  </mat-error>
                </mat-form-field>
              </ng-container>
              <ng-container *ngIf="questionnaire.position === 1">
                <mat-slider
                  class="slider"
                  [max]="10"
                  [min]="1"
                  [step]="1"
                  [thumbLabel]="true"
                  [(value)]="sliderValue1"
                  (change)="setResult(questionnaire.position)">
                </mat-slider>
              </ng-container>
              <ng-container *ngIf="questionnaire.position === 5">
                <mat-slider
                  class="slider"
                  [max]="10"
                  [min]="1"
                  [step]="1"
                  [thumbLabel]="true"
                  [(value)]="sliderValue5"
                  (change)="setResult(questionnaire.position)">
                </mat-slider>
              </ng-container>
              <ng-container *ngIf="questionnaire.position !== 1 && questionnaire.position !== 3 && questionnaire.position !== 5">
                <mat-form-field>
                  <mat-label>Seleziona un valore</mat-label>
                  <mat-select required>
                    <mat-option *ngFor="let value of questionnaire.answers" [value]="value"
                                (onSelectionChange)="selectResult($event, value, questionnaire.position, questionnaire.answers)">
                      {{value}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-container>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

      </div>


      <div style="text-align: center; padding-top: 50px">
        <ng-container *ngIf="submitted">
          <div style="justify-content: center; align-content: center; align-items: center; padding-bottom: 50px">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </div>
        </ng-container>

        <div style="text-align: center">
          <ng-container *ngIf="!show">
            <button  class="mat-elevation-z4" mat-raised-button type="submit" color="primary"
                     [disabled]="!qForm.valid">Invia</button>
          </ng-container>
        </div>
      </div>

    </form>
  </div>
</ng-container>
<ng-template #noAuth>
  <app-toolbar [back]="back" [destination]="destination" [title]="'Accesso non autorizzato'" [user]="user"></app-toolbar>
  <div style="padding-bottom: 20px; padding-top: 20px; text-align: center;">
    <h4>
      L'accesso a questa pagina non è autorizzato. Torna alla home
    </h4>
    <button mat-raised-button color="warn" (click)="goHome()">Home</button>
  </div>
</ng-template>
